export default "__VITE_ASSET__BfFSsAgT__"